export interface IConfigsConsultValues{
    showPeriods: string;
    divider: string;
    variation: string;
    listItens: string;
    showColumnPlanned: string;
    showColumnRealized: string;
    showColumnLastYear: string;
    showVariationValue: string;
    showVariationPercent: string;
    
    coinPlanned: number | null;
    coinPlannedInitials: string | null;
    coinRealized: number | null;
    coinRealizedInitials: string | null;
}

export interface IFormOptionsConsultValues{
    subsidiary: string;
    grouper: string;
    startDate: Date | null;
    endDate: Date | null;
    showLevelBelow: boolean;
    showHierarchy: boolean;
    [key: string]: any;
}

export enum BudgetType{
   VARIABLES_COSTS = "CV",
   SALES_REVENUE = "RE",
   OPERATIONAL_EXPENSES = "DO",
   OTHER_EXPENSES = "OU",
   SALE_DEDUCTION = "DE",
   VARIABLES_EXPENSES = "DV", 
}

interface IValuesTable{
    date: Date | null;
    predicted: number;
    realized: number;
    lastYear: number;
    variationValue: number;
    variationPercent: number;
}

export interface IDataTable{
    description: string;
    values: IValuesTable[];
    accumulatedValues: IValuesTable;
    children: IDataTable[];
}
